import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';

export const HiddenWrapperStyled = styled('div')`
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: ${globalZindex.hiddenElement};
  opacity: 0;
  transform: translate(-100%, -100%);
  visibility: hidden;
  pointer-events: none;
  user-select: none;
`;
